import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from '../constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH,
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
    color: PDF_STYLES_CONSTANTS.COLORS.PRIMARY_DARK,
  },
  descriptionImage: {
    width: '100%',
    maxHeight: 550,
    objectFit: 'contain',
  },
  descriptionText: {
    marginTop: PDF_STYLES_CONSTANTS.SPACING.MARGIN_TOP_SMALL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.TINY,
  },
  reportTitle: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.X_LARGE,
    textAlign: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: PDF_STYLES_CONSTANTS.SPACING.MARGIN_TOP_MEDIUM,
    marginBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.TINY,
  },
  description: {
    marginTop: PDF_STYLES_CONSTANTS.SPACING.MARGIN_TOP_SMALL,
  },
  descriptionTruncate: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxLines: 5,
  },
});

export default styles;
